const GET_ACTIVE_ASSET_COST_CENTER_DROP_DOWN = 'GET_ACTIVE_ASSET_COST_CENTER_DROP_DOWN'
const SET_ACTIVE_ASSET_COST_CENTER_DROP_DOWN = 'SET_ACTIVE_ASSET_COST_CENTER_DROP_DOWN'

const GET_ACTIVE_ASSET_MAKE_DROP_DOWN = 'GET_ACTIVE_ASSET_MAKE_DROP_DOWN'
const SET_ACTIVE_ASSET_MAKE_DROP_DOWN = 'SET_ACTIVE_ASSET_MAKE_DROP_DOWN'

const GET_ACTIVE_ASSET_MODEL_DROP_DOWN = 'GET_ACTIVE_ASSET_MODEL_DROP_DOWN'
const SET_ACTIVE_ASSET_MODEL_DROP_DOWN = 'SET_ACTIVE_ASSET_MODEL_DROP_DOWN'

const GET_ACTIVE_ASSET_YEAR_DROP_DOWN = 'GET_ACTIVE_ASSET_YEAR_DROP_DOWN'
const SET_ACTIVE_ASSET_YEAR_DROP_DOWN = 'SET_ACTIVE_ASSET_YEAR_DROP_DOWN'

const GET_ACTIVE_ASSET_GL_CATEGORY_DROP_DOWN = 'GET_ACTIVE_ASSET_GL_CATEGORY_DROP_DOWN'
const SET_ACTIVE_ASSET_GL_CATEGORY_DROP_DOWN = 'SET_ACTIVE_ASSET_GL_CATEGORY_DROP_DOWN'

const GET_ACTIVE_ASSET_ASSET_CATEGORY_DROP_DOWN = 'GET_ACTIVE_ASSET_ASSET_CATEGORY_DROP_DOWN'
const SET_ACTIVE_ASSET_ASSET_CATEGORY_DROP_DOWN = 'SET_ACTIVE_ASSET_ASSET_CATEGORY_DROP_DOWN'

const GET_ACTIVE_ASSET_EQ_CLASS_CODE_DROP_DOWN = 'GET_ACTIVE_ASSET_EQ_CLASS_CODE_DROP_DOWN'
const SET_ACTIVE_ASSET_EQ_CLASS_CODE_DROP_DOWN = 'SET_ACTIVE_ASSET_EQ_CLASS_CODE_DROP_DOWN'

const GET_ACTIVE_ASSET_STATE_DROP_DOWN = 'GET_ACTIVE_ASSET_STATE_DROP_DOWN'
const SET_ACTIVE_ASSET_STATE_DROP_DOWN = 'SET_ACTIVE_ASSET_STATE_DROP_DOWN'

export {
    GET_ACTIVE_ASSET_COST_CENTER_DROP_DOWN,
    SET_ACTIVE_ASSET_COST_CENTER_DROP_DOWN,
    GET_ACTIVE_ASSET_MAKE_DROP_DOWN,
    SET_ACTIVE_ASSET_MAKE_DROP_DOWN,
    GET_ACTIVE_ASSET_MODEL_DROP_DOWN,
    SET_ACTIVE_ASSET_MODEL_DROP_DOWN,
    GET_ACTIVE_ASSET_YEAR_DROP_DOWN,
    SET_ACTIVE_ASSET_YEAR_DROP_DOWN,
    GET_ACTIVE_ASSET_GL_CATEGORY_DROP_DOWN,
    SET_ACTIVE_ASSET_GL_CATEGORY_DROP_DOWN,
    GET_ACTIVE_ASSET_ASSET_CATEGORY_DROP_DOWN,
    SET_ACTIVE_ASSET_ASSET_CATEGORY_DROP_DOWN,
    GET_ACTIVE_ASSET_EQ_CLASS_CODE_DROP_DOWN,
    SET_ACTIVE_ASSET_EQ_CLASS_CODE_DROP_DOWN,
    GET_ACTIVE_ASSET_STATE_DROP_DOWN,
    SET_ACTIVE_ASSET_STATE_DROP_DOWN
}